import { Theme } from "@mui/material/styles";

declare module "@mui/material/List" {
    interface ListPropsVariantOverrides {
        moja: true;
    }
}

export default function List(theme: Theme) {
    return {
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: "text.icon",
                    minWidth: "auto",
                    marginRight: theme.spacing(2),
                    width: 20,
                    height: 20,
                },
            },
        },
        MuiListItemAvatar: {
            styleOverrides: {
                root: {
                    minWidth: "auto",
                    marginRight: theme.spacing(2),
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    marginTop: 0,
                    marginBottom: 0,
                },
                multiline: {
                    marginTop: 0,
                    marginBottom: 0,
                },
            },
        },
    };
}
